import { AdvancedFilterInputSchema } from "@redotech/redo-fulfillment-common/fulfillment-group-summary-input";
import * as z from "zod";

export const getShippingClaimUniqueValues = {
  name: "getShippingClaimUniqueValues" as const,
  input: AdvancedFilterInputSchema.extend({
    filterName: z.string(),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ values: z.array(z.string()) }),
};
